<template>
  <div class="login-container">
    <h1>{{ Config.APP_NAME }}<br>ログイン画面</h1>

    <div class="input-container">
      <form @submit.prevent="login" v-if="!isLoading">
        <label>ログインID（メールアドレス）:<input inputmode="email" v-model="req.email" type="text" name="email" id="email"
            autocorrect="off" autocapitalize="off" autocomplete="email"></label>
        <label>パスワード：<input v-model="req.password" inputmode="text" type="password" name="password" id="password"
            autocomplete="current-password"></label>
        <button type="submit" class="btn-login btn success">ログイン</button>
      </form>
      <loading v-else="isLoading" :message='"ログイン中です"'></loading>
      <p class="forgot-password" v-if="!isLoading && isJinji">パスワードを忘れた場合は<router-link
          :to="{ name: 'forgotPassword' }">こちら</router-link></p>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, Ref, ref } from 'vue'
import { AuthApi } from '@/api/AuthApi'
import { LoginReq } from '@/types/User'
import router from '@/routers'
import { UtilService } from '@/service/UtilService'
import Config from '@/const/Config'
import { RouterConst } from '@/const/Router'
import { useOperationSupportLog } from '@/composable/operation_support/log'
import { OperationSupportLog } from '@/types/OperationSupport'
import { APP_MODE } from '@/const/Constants'

export default defineComponent({
  setup() {
    const { saveLog } = useOperationSupportLog()

    const req: Ref<LoginReq> = ref({
      email: '',
      password: ''
    });

    let isLoading = ref(false)
    let isJinji = ref(false)

    onMounted(async () => {
      isJinji.value = (Config.APP_MODE === APP_MODE.JINJI);
      try {
        // ネイテイブアプリでこの画面にアクセスした場合のメッセージ
        window.VueLoginScreen.postMessage('');
        const log = new OperationSupportLog()
        await log.setLogInfo('ログイン画面', 'ログイン画面へのアクセス')
        await saveLog(log)
      } catch (e) {
        // ログの記録失敗時に処理続行するよう握りつぶす
      }
    })

    const login = async () => {
      isLoading.value = true
      const api = new AuthApi();

      let result = false
      try {
        result = await api.login(req.value);
      } catch (e) {
        await UtilService.showAuthErrorDialog(false);
        isLoading.value = false
        return
      }

      if (result) {
        router.push({ name: RouterConst.AUTH });
      }
      isLoading.value = false
    }

    return {
      login,
      req,
      Config,
      isLoading,
      isJinji
    }
  }
})
</script>

<style lang="scss" scoped>
@import '@scss/pages/login.scss';
</style>
